<template>
  <header class="header">
    <div class="header__block header__block--brand">
      <button
        v-if="isSidebarToggleable"
        type="button"
        @click="setSidebar(!sidebar)"
        class="header__brand header__brand--interactive"
      >
        <font-awesome-icon
          :icon="'bars'"
          size="lg"
        />
        <strong>{{sidebarName}}</strong>
      </button>
      <div
        class="header__brand"
        v-else
      >
        <strong>{{sidebarName}}</strong>
      </div>
    </div>
    <div class="header__block header__block--breadcrumbs">
      <Breadcrumbs></Breadcrumbs>
    </div>
    <div
      class="header__block header__block--user text-right"
      v-if="loggedIn && user"
    >
      <Dropdown
        :items="actions"
        :label="user.username"
        :key="actions.length"
        caret="chevron-down"
      ></Dropdown>
    </div>
    <button
      type="button"
      @click="setNotifications(!notifications)"
      class="btn btn-link"
    >
      <font-awesome-icon
        :icon="'bell'"
        size="lg"
      />
    </button>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Breadcrumbs from './Breadcrumbs.vue';
import Dropdown from '@/components/Dropdown';

export default {
  name: 'Header',
  components: {
    Breadcrumbs,
    Dropdown,
  },
  computed: {
    actions() {
      const staticItems = [
        {
          label: 'Profile',
          action: () => {
            this.profile();
          },
        },
        {
          label: 'Logout',
          action: () => {
            this.logout();
          },
        },
      ];

      // @todo: change to permissions condition
      if (window.location.host !== 'localhost:8080') {
        return staticItems;
      }

      const items = this.doMenuFormat(this.items);
      if (typeof items[0].items === 'undefined') {
        return staticItems;
      }
      return staticItems.concat(['break']).concat(items[0].items);
    },
    ...mapState({
      notifications: state => state.layout.notifications,
      sidebar: state => state.layout.sidebar,
      isSidebarToggleable: state => state.layout.isSidebarToggleable,
      sidebarName: state => state.layout.sidebarName,
    }),
    items() {
      return this.$store.state.menus.entries.filter(item => {
        return item.parent === 'admin';
      });
    },
  },
  methods: {
    ...mapActions({
      setSidebar: 'layout/sidebar',
      setNotifications: 'layout/notifications',
    }),
    logout() {
      window.location.href = `${this.apiBaseUri}/logout?redirect=${
        window.location.href
      }`;
    },
    profile() {
      this.goTo({ name: 'profile' });
    },
    goTo(params) {
      this.$router.push(params);
    },
  },
  created() {
    this.$store.dispatch('menus/get');
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  padding: 0 $padding 0 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: $header-height;
  border-bottom: 1px solid $muted;
  background-color: $inverse;
  z-index: 1;

  .header__block {
    flex: 1;
  }

  .header__block--brand {
    min-width: $sidebar-width;
    max-width: $sidebar-width;
    height: $header-height;
    display: flex;
    border-right: 1px solid $muted;
  }

  .header__block--breadcrumbs {
    padding-left: $padding;
  }

  .header__block--user {
    max-width: 100px;
  }
}
.header__brand {
  font-size: 12px;
  color: $fill-info;
  padding-left: 20px;
  align-self: center;
}
.header__brand--interactive {
  border-color: transparent;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  padding-left: 0;
  .svg-inline--fa {
    width: 60px;
  }
  &:hover {
    color: $fill-default;
  }
}
</style>
